  document.addEventListener('DOMContentLoaded', function () {

    new Swiper(".imageSlider", {
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      speed: 800,
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: ".imageSlider-next",
        prevEl: ".imageSlider-prev",
      },
    });


    new Swiper(".best-seller-swiper", {
      slidesPerView: 1,
      spaceBetween: 16,
      

      navigation: {
        nextEl: ".bs-next",
        prevEl: ".bs-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
         
        },
      },
    });
  });